/* Art1 White Cube – Verhalten im Browser. Ohne Abhängigkeiten.
   Alles funktioniert auch ohne JavaScript; dieses Skript verbessert nur. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var qs = function (selector, root) { return (root || document).querySelector(selector); };
  var qsa = function (selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); };
  var store = {
    get: function (key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } },
    set: function (key, value) { try { window.localStorage.setItem(key, value); } catch (e) { /* privater Modus */ } }
  };
  var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

  /* ---------- Panels (Menü, Warenkorb) ---------- */
  function openDrawer(dialog, trigger) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.style.overflow = 'hidden';
    dialog._trigger = trigger || null;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer(dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  qsa('dialog[data-drawer]').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (dialog._trigger) {
        dialog._trigger.setAttribute('aria-expanded', 'false');
        dialog._trigger.focus();
      }
    });
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      closeDrawer(closer.closest('dialog'));
      return;
    }
    if (event.target.matches && event.target.matches('dialog.drawer')) {
      closeDrawer(event.target);
    }
  });

  /* ---------- Warenkorb ---------- */
  function cartDrawer() { return document.getElementById('CartDrawer'); }

  function updateCartCount(count) {
    if (count === null || count === undefined) return;
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  }

  function renderCartDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-cart-drawer-inner]', doc);
    var current = qs('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    if (fresh) updateCartCount(fresh.getAttribute('data-count'));
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cart-link]');
    if (!link || theme.cartType !== 'drawer' || !cartDrawer()) return;
    event.preventDefault();
    openDrawer(cartDrawer(), link);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form || theme.cartType !== 'drawer' || !cartDrawer() || !window.fetch) return;
    event.preventDefault();

    var buttons = qsa('[data-add-button]', form).concat(qsa('button[form="' + form.id + '"]'));
    var errorBox = qs('[data-form-error]', form);
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || theme.strings.cartError);
        }
        if (errorBox) errorBox.hidden = true;
        renderCartDrawer(result.data.sections && result.data.sections['cart-drawer']);
        openDrawer(cartDrawer());
      })
      .catch(function (error) {
        if (errorBox) {
          errorBox.textContent = error.message || theme.strings.cartError;
          errorBox.hidden = false;
        }
      })
      .finally(function () {
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
      });
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-line-remove]');
    if (!remove || !remove.closest('[data-cart-drawer]') || !window.fetch) return;
    event.preventDefault();
    fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(remove.getAttribute('data-line-remove')), quantity: 0, sections: 'cart-drawer' })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) { renderCartDrawer(data.sections && data.sections['cart-drawer']); })
      .catch(function () { window.location.href = remove.href; });
  });

  var cartForm = document.getElementById('CartForm');
  if (cartForm) {
    cartForm.addEventListener('change', function (event) {
      if (event.target.name === 'updates[]') cartForm.submit();
    });
  }

  /* ---------- Produktgalerie, Wandansicht, Lightbox ---------- */
  qsa('[data-gallery]').forEach(function (gallery) {
    var slides = qsa('.gallery__slide', gallery);
    var thumbs = qsa('[data-thumb]', gallery);
    gallery._show = function (key) {
      key = String(key);
      slides.forEach(function (slide) { slide.classList.toggle('is-active', slide.getAttribute('data-slide') === key); });
      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-thumb') === key;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { gallery._show(thumb.getAttribute('data-thumb')); });
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-show-wall]');
    if (!trigger) return;
    var section = trigger.closest('[data-product]');
    var gallery = section && qs('[data-gallery]', section);
    if (!gallery || !gallery._show) return;
    gallery._show('wall');
    var rect = gallery.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.6) {
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('click', function (event) {
    var zoom = event.target.closest('[data-zoom-src]');
    if (zoom) {
      var section = zoom.closest('[data-product]');
      var box = section && qs('[data-lightbox]', section);
      if (!box || typeof box.showModal !== 'function') return;
      var stage = qs('[data-lightbox-stage]', box);
      stage.innerHTML = '';
      var img = new Image();
      img.src = zoom.getAttribute('data-zoom-src');
      img.alt = zoom.getAttribute('data-zoom-alt') || '';
      img.addEventListener('click', function () { box.close(); });
      stage.appendChild(img);
      box.showModal();
      return;
    }
    var close = event.target.closest('[data-lightbox-close]');
    if (close) close.closest('dialog').close();
  });

  /* ---------- Varianten ---------- */
  function optionValues(option) {
    return [1, 2, 3].map(function (i) { return option.getAttribute('data-option' + i) || ''; });
  }

  function updateWall(section, option) {
    var wall = qs('[data-wall]', section);
    var w = parseFloat(option.getAttribute('data-w'));
    var h = parseFloat(option.getAttribute('data-h'));
    if (wall && w > 0 && h > 0 && wall.getAttribute('data-parts') === '1') {
      var sofa = Number(wall.getAttribute('data-sofa')) || 200;
      var bottom = Number(wall.getAttribute('data-bottom')) || 110;
      var wallW = Math.max(320, w + 120, sofa + 80);
      var wallH = Math.max(240, bottom + h + 25);
      wall.style.setProperty('--grp-w', w);
      wall.style.setProperty('--grp-h', h);
      wall.style.setProperty('--wall-w', wallW);
      wall.style.setProperty('--wall-h', wallH);
      var dim = qs('[data-wall-dim]', wall);
      if (dim) dim.textContent = option.getAttribute('data-dims');
      var tip = qs('[data-wall-tip]', wall);
      if (tip) tip.hidden = false;
    }
    if (wall) {
      var title = (option.textContent || '').toLowerCase();
      var flags = [];
      if (/rahmen|schattenfuge/.test(title)) flags.push('frame');
      if (/acryl/.test(title)) flags.push('acrylic');
      wall.setAttribute('data-finish', flags.join(' '));
    }
    if (option.getAttribute('data-dims')) {
      qsa('[data-art-dims]', section).forEach(function (el) { el.textContent = option.getAttribute('data-dims'); });
    }
  }

  function updateFinishInfo(section, option) {
    var selected = optionValues(option).map(function (v) { return v.toLowerCase().trim(); });
    qsa('[data-finish-info]', section).forEach(function (el) {
      el.hidden = selected.indexOf(el.getAttribute('data-finish-info')) === -1;
    });
  }

  function updateEditionLeft(section, option) {
    var el = qs('[data-edition-left]', section);
    if (!el) return;
    var inv = option.getAttribute('data-inv');
    if (inv === null || Number(inv) < 1) { el.hidden = true; return; }
    el.textContent = (el.getAttribute('data-template') || '').replace('__N__', inv);
    el.hidden = false;
  }

  function syncPicker(section, select) {
    var picker = qs('[data-variant-picker]', section);
    if (!picker) return;
    var options = Array.prototype.slice.call(select.options);
    var current = select.options[select.selectedIndex];
    var chosen = optionValues(current);
    qsa('fieldset[data-option-index]', picker).forEach(function (fieldset) {
      var index = Number(fieldset.getAttribute('data-option-index'));
      var label = qs('[data-option-current]', fieldset);
      if (label) label.textContent = chosen[index];
      qsa('[data-option-input]', fieldset).forEach(function (input) {
        input.checked = input.value === chosen[index];
        var possible = options.some(function (opt) {
          var values = optionValues(opt);
          if (values[index] !== input.value || opt.getAttribute('data-available') !== 'true') return false;
          return values.every(function (v, i) { return i === index || !chosen[i] || v === chosen[i]; });
        });
        input.closest('.option__pill').classList.toggle('is-unavailable', !possible);
        if (possible) input.removeAttribute('aria-label');
        else input.setAttribute('aria-label', input.value + ' – ' + (theme.strings.unavailable || ''));
      });
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-option-input]');
    if (!input) return;
    var section = input.closest('[data-product]');
    var picker = input.closest('[data-variant-picker]');
    var select = section && qs('[data-variant-select]', section);
    if (!select || !picker) return;
    var wanted = qsa('fieldset[data-option-index]', picker).map(function (fieldset) {
      var checked = qs('[data-option-input]:checked', fieldset);
      return checked ? checked.value : '';
    });
    var options = Array.prototype.slice.call(select.options);
    var exact = options.filter(function (opt) {
      var values = optionValues(opt);
      return wanted.every(function (v, i) { return !v || values[i] === v; });
    });
    var changedIndex = Number(input.closest('fieldset').getAttribute('data-option-index'));
    var match = exact[0] || options.filter(function (opt) {
      return optionValues(opt)[changedIndex] === input.value && opt.getAttribute('data-available') === 'true';
    })[0];
    if (!match) { syncPicker(section, select); return; }
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-variant-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var section = select.closest('[data-product]');
    var priceHtml = option.getAttribute('data-price');
    var available = option.getAttribute('data-available') === 'true';
    qsa('[data-product-price] .price__now', section).forEach(function (el) { el.innerHTML = priceHtml; });
    var stickyPrice = qs('[data-sticky-price]', section);
    if (stickyPrice) stickyPrice.innerHTML = priceHtml;
    qsa('[data-add-button], [data-sticky-add]', section).forEach(function (button) {
      if (button.closest('.series-add')) return;
      button.disabled = !available;
      button.textContent = available ? theme.strings.addToCart : theme.strings.soldOut;
    });
    updateWall(section, option);
    updateFinishInfo(section, option);
    updateEditionLeft(section, option);
    syncPicker(section, select);
    if (window.history && window.URL) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    }
  });

  function initPickers(root) {
    qsa('[data-variant-select]', root).forEach(function (select) {
      var section = select.closest('[data-product]');
      if (section) syncPicker(section, select);
    });
  }
  initPickers(document);
  document.addEventListener('shopify:section:load', function (event) { initPickers(event.target); });

  /* ---------- Aufklappbereich per Link öffnen (z. B. Farbhinweis) ---------- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-open-details]');
    if (!link) return;
    var details = document.getElementById(link.getAttribute('data-open-details'));
    if (!details) return;
    event.preventDefault();
    details.open = true;
    details.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var summary = qs('summary', details);
    if (summary) summary.focus({ preventScroll: true });
  });

  /* ---------- Mitlaufende Kaufleiste ---------- */
  qsa('[data-product]').forEach(function (section) {
    var bar = qs('[data-sticky-buy]', section);
    var mainButton = qs('[data-add-button]', section);
    if (!bar || !mainButton || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !passed;
      document.body.classList.toggle('has-sticky-buy', passed);
    });
    observer.observe(mainButton);
  });

  /* ---------- Filter ---------- */
  qsa('[data-facets-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (event) {
      if (!event.target.hasAttribute('data-facets-change')) return;
      window.clearTimeout(timer);
      var delay = event.target.type === 'number' ? 700 : 0;
      timer = window.setTimeout(function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }, delay);
    });
    form.addEventListener('submit', function () {
      qsa('input[type="number"]', form).forEach(function (input) {
        if (input.value === '') input.disabled = true;
      });
    });
  });

  /* ---------- Künstler-Biografie ---------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-read-more-toggle]');
    if (!toggle) return;
    var target = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!target) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    target.classList.toggle('is-expanded', !expanded);
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = expanded ? toggle.getAttribute('data-label-more') : toggle.getAttribute('data-label-less');
  });

  /* ---------- Kopfbereich: Suche, Untermenüs ---------- */
  qsa('[data-header-search]').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      var input = qs('input[type="search"]', details);
      if (input) input.focus();
    });
  });

  document.addEventListener('click', function (event) {
    qsa('details[data-dropdown][open], details[data-header-search][open]').forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qsa('details[data-dropdown][open], details[data-header-search][open]').forEach(function (details) {
      details.open = false;
      var summary = qs('summary', details);
      if (summary) summary.focus();
    });
  });

  /* ---------- Empfehlungen nachladen ---------- */
  qsa('[data-recommendations]').forEach(function (el) {
    if (el.children.length || !window.fetch) return;
    fetch(el.getAttribute('data-url'))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* Empfehlungen sind optional */ });
  });

  /* ---------- Messe: Countdown und Ausblenden ---------- */
  qsa('[data-event]').forEach(function (section) {
    var start = section.getAttribute('data-start');
    var end = section.getAttribute('data-end') || start;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(start)) return;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var startDate = new Date(start + 'T00:00:00');
    var endDate = new Date(end + 'T00:00:00');
    if (today > endDate) {
      if (section.getAttribute('data-hide-after-end') === 'true') section.hidden = true;
      return;
    }
    var label = qs('[data-event-countdown]', section);
    if (!label) return;
    var days = Math.round((startDate - today) / 86400000);
    var text;
    if (days > 1) text = label.getAttribute('data-label-days').replace('__N__', days);
    else if (days === 1) text = label.getAttribute('data-label-one');
    else if (days === 0) text = label.getAttribute('data-label-today');
    else text = label.getAttribute('data-label-running');
    label.textContent = text;
    label.hidden = false;
  });

  /* ---------- Kontaktformular vorausfüllen ---------- */
  var subjectField = qs('[data-prefill-subject]');
  var bodyField = qs('[data-prefill-body]');
  if ((subjectField || bodyField) && window.URLSearchParams) {
    var params = new URLSearchParams(window.location.search);
    var subject = params.get('betreff');
    var work = params.get('werk');
    if (subjectField && subject && !subjectField.value) subjectField.value = subject.slice(0, 200);
    if (bodyField && work && /^\/[\w\-\/]+$/.test(work) && !bodyField.value) {
      bodyField.value = (bodyField.getAttribute('data-work-label') || 'Werk') + ': ' + window.location.origin + work + '\n\n';
    }
  }

  var formStatus = qs('#ContactForm [data-form-status]');
  if (formStatus) formStatus.focus();

  /* ---------- Newsletter-Hinweis ---------- */
  var popup = qs('[data-newsletter-popup]');
  if (popup) {
    var views = Number(store.get('a1_views') || 0) + 1;
    store.set('a1_views', String(views));
    var dismissedAt = Number(store.get('a1_popup_dismissed') || 0);
    var recentlyDismissed = dismissedAt && Date.now() - dismissedAt < 30 * 86400000;
    var forced = window.location.hash === '#NewsletterPopupForm';
    var blockedHere = document.body.classList.contains('template-cart') ||
      (!isDesktop() && qs('[data-sticky-buy]'));

    var showPopup = function () { popup.hidden = false; };
    if (forced) {
      showPopup();
    } else if (!recentlyDismissed && !blockedHere && views >= Number(popup.getAttribute('data-min-views') || 2)) {
      window.setTimeout(showPopup, Number(popup.getAttribute('data-delay') || 0) * 1000);
    }

    var popupClose = qs('[data-popup-close]', popup);
    if (popupClose) {
      popupClose.addEventListener('click', function () {
        popup.hidden = true;
        store.set('a1_popup_dismissed', String(Date.now()));
      });
    }
    popup.addEventListener('submit', function () {
      store.set('a1_popup_dismissed', String(Date.now()));
    });
  }
})();
